<template>
  <v-container fluid pa-1>
    <v-row :dense="!isDesktopView">
      <v-col
        v-if="cancelable"
        :class="{ 'text-left': isDesktopView }"
        cols="12"
        sm="auto"
      >
        <slot name="controls-cancel" :cancel="cancel">
          <bm-btn
            button-type="secondary"
            :block="!isDesktopView"
            data-qa="dialog_cancel"
            :x-large="large"
            @click="cancel"
          >
            <slot name="controls-cancel-text">
              {{ $m.cancel }}
            </slot>
          </bm-btn>
        </slot>
      </v-col>
      <v-spacer />
      <v-col
        :cols="cancelable && isDesktopView ? 'auto' : 12"
        :sm="cancelable ? 'auto' : 12"
        :class="{ 'text-right': isDesktopView }"
        :order="isDesktopView ? undefined : 'first'"
      >
        <slot
          name="controls-confirm"
          :valid="valid"
          :dirty="dirty"
          :accept="accept"
          :is-desktop-view="isDesktopView"
        >
          <bm-btn
            :button-type="dialogType.confirmButtonClass"
            :disabled="!valid || !dirty"
            :block="!isDesktopView"
            data-qa="dialog_accept"
            :x-large="large"
            @click="accept"
          >
            <slot name="controls-confirm-text">
              {{ $m.save }}
            </slot>
          </bm-btn>
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { EnumDialogType } from "@/components/dialogs/DialogTypes";
import BmBtn from "@/components/controls/input/BmBtn.vue";
import { screenSize } from "@/vue23switching/screenSize";

/**
 * Generic BmDialogControls component
 *
 * @slots
 * 'controls-confirm', to replace only the confirm button
 * 'controls-confirm-text', to replace only the confirm button text
 * 'controls-cancel', 'controls-cancel-text', mimic the above respectively
 *
 * @events
 * 'cancel', normally used to close the menu
 * 'accept', confirm/submit the contents of the dialog
 */

interface BmDialogControlsProps {
  accept: () => void;
  cancel: () => void;
  valid?: boolean;
  dirty?: boolean;
  cancelable?: boolean;
  dialogType?: EnumDialogType;
  large?: boolean;
}

withDefaults(defineProps<BmDialogControlsProps>(), {
  valid: true,
  dirty: true,
  cancelable: true,
  dialogType: () => EnumDialogType.info,
  large: false,
});

const isDesktopView = computed(() => screenSize.smAndUp);
</script>
